<template>
    <div>
        <div class="account-pages mx-md-5 my-5 pt-sm-5">
            <div class="container-fluid">
                <div :class="$root.loginPanelClass()">
                    <div class="col-sm-6 col-lg-4 col-xl-3 login-panel-col">
                        <div class="card overflow-hidden">
                            <div :class="$root.app.login_panel_header_class + ' px-4 py-2 text-center'">
                                <img
                                    v-if="$root.app.login_logo"
                                    :src="$root.app.login_logo"
                                    :alt="$root.client.client_name"
                                    class="img-fluid"
                                >
                            </div>
                            <div class="card-body pt-2 pb-1">
                                <div v-if="$root.getAvailableLanguages().length > 1" class="text-right m-2">
                                    <language-select></language-select>
                                </div>

                                <div class="p-2">
                                    <div v-if="errors" v-html="errors" class="alert alert-danger" role="alert"></div>

                                    <div v-if="password_expired">
                                        <div class="form-group">
                                            <button
                                                type="button"
                                                class="btn btn-primary"
                                                data-toggle="modal"
                                                data-target="#forgotten-password-modal"
                                                @click="resetForgottenPasswordForm({ expired: true })"
                                                style="width: 100%"
                                            >
                                                <i class="far fa-key mr-1"></i>
                                                {{ $root.text('Change password', null, true) }}
                                            </button>
                                        </div>
                                    </div>

                                    <!--<div v-if="account_locked">
                                        <div class="form-group">
                                            <button
                                                type="button"
                                                class="btn btn-primary"
                                                data-toggle="modal"
                                                data-target="#email-support-modal"
                                                @click="resetSupportForm('locked')"
                                                style="width: 100%"
                                            >
                                                <i class="far fa-envelope mr-1"></i> Email support
                                            </button>
                                        </div>
                                    </div>-->

                                    <div v-if="user_unapproved && can_chase">
                                        <div class="form-group">
                                            <button
                                                type="button"
                                                class="btn btn-primary"
                                                @click="chaseApproval('unapproved')"
                                                style="width: 100%"
                                                :disabled="chase_approval_timer ? true : false"
                                            >
                                                <i class="far fa-envelope mr-1"></i>
                                                
                                                <span v-if="chase_approval_timer">
                                                    {{ $root.text('Chase my application in {minutes}',
                                                        { minutes: chaseApprovalTime() }, true) }}
                                                </span>
                                                <span v-else>{{ $root.text('Chase my application', null, true) }}</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div v-if="approval_chased" class="alert alert-success" role="alert">
                                        <div class="row no-gutters">
                                            <div class="col-1" style="max-width: 30px"><i class="far fa-check"></i></div>
                                            <div class="col">
                                                {{ $root.text('Your application has been chased.', null, true) }}
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="email_not_verified">
                                        <div class="form-group">
                                            <button
                                                type="button"
                                                class="btn btn-primary"
                                                data-toggle="modal"
                                                data-target="#email-support-modal"
                                                @click="resetSupportForm('not-verified')"
                                                style="width: 100%"
                                            >
                                                <i class="far fa-envelope mr-1"></i>
                                                {{ $root.text('Email support', null, true) }}
                                            </button>
                                        </div>
                                    </div>

                                    <div v-if="loading"><loading></loading></div>

                                    <div v-if="(!loading && enter_code)">
                                        <form v-on:submit.prevent="onSubmit(true)">
                                            <div v-if="resend_code">
                                                <div class="form-group">
                                                    {{
                                                        $root.text(
                                                            'Sometimes system-generated emails go into your junk, spam '
                                                                + 'or deleted folder. Please check there.',
                                                            null,
                                                            true
                                                        )
                                                    }}
                                                </div>
                                                <div class="form-group mt-3">
                                                    <button
                                                        :key="'resend-code-button'"
                                                        type="button"
                                                        class="btn btn-primary btn-block"
                                                        @click="resendCode()"
                                                    >
                                                        <i class="far fa-undo-alt mr-1"></i>
                                                        {{ $root.text('Resend code', null, true) }}
                                                    </button>
                                                </div>
                                                <div class="form-group">
                                                    <button
                                                        :key="'resend-code-cancel'"
                                                        type="button"
                                                        class="btn btn-light btn-block"
                                                        @click="toggleResendCode()"
                                                    >
                                                        <i class="far fa-times mr-1"></i>
                                                        {{ $root.text('cancel', null, true) }}
                                                    </button>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <label
                                                    for="login_code_1"
                                                    id="login_code-label"
                                                    class="mandatory-label mb-3"
                                                >
                                                    {{
                                                        $root.text(
                                                            'For added security use the verification code sent to your '
                                                                + 'email. No code? Check spam/junk.',
                                                            null,
                                                            true
                                                        )
                                                    }}
                                                </label>
                                                <div class="row px-2">
                                                    <div class="col-2 px-1">
                                                        <div class="form-group">
                                                            <input
                                                                v-model="code_1"
                                                                type="text"
                                                                v-mask="'######'"
                                                                id="login_code_1"
                                                                class="form-control mandatory-field"
                                                                :readonly="loading"
                                                                style="font-size: 1.5rem; text-align: center"
                                                                v-on:keyup="$root.unHighlightErrors('login_code_1')"
                                                                v-on:change="$root.unHighlightErrors('login_code_1')"
                                                            >
                                                        </div>
                                                    </div>
                                                    <div class="col-2 px-1">
                                                        <div class="form-group">
                                                            <input
                                                                v-model="code_2"
                                                                type="text"
                                                                v-mask="'######'"
                                                                id="login_code_2"
                                                                class="form-control mandatory-field"
                                                                :readonly="loading"
                                                                style="font-size: 1.5rem; text-align: center"
                                                                v-on:keyup="$root.unHighlightErrors('login_code_2')"
                                                                v-on:change="$root.unHighlightErrors('login_code_2')"
                                                            >
                                                        </div>
                                                    </div>
                                                    <div class="col-2 px-1">
                                                        <div class="form-group">
                                                            <input
                                                                v-model="code_3"
                                                                type="text"
                                                                v-mask="'######'"
                                                                id="login_code_3"
                                                                class="form-control mandatory-field"
                                                                :readonly="loading"
                                                                style="font-size: 1.5rem; text-align: center"
                                                                v-on:keyup="$root.unHighlightErrors('login_code_3')"
                                                                v-on:change="$root.unHighlightErrors('login_code_3')"
                                                            >
                                                        </div>
                                                    </div>
                                                    <div class="col-2 px-1">
                                                        <div class="form-group">
                                                            <input
                                                                v-model="code_4"
                                                                type="text"
                                                                v-mask="'######'"
                                                                id="login_code_4"
                                                                class="form-control mandatory-field"
                                                                :readonly="loading"
                                                                style="font-size: 1.5rem; text-align: center"
                                                                v-on:keyup="$root.unHighlightErrors('login_code_4')"
                                                                v-on:change="$root.unHighlightErrors('login_code_4')"
                                                            >
                                                        </div>
                                                    </div>
                                                    <div class="col-2 px-1">
                                                        <div class="form-group">
                                                            <input
                                                                v-model="code_5"
                                                                type="text"
                                                                v-mask="'######'"
                                                                id="login_code_5"
                                                                class="form-control mandatory-field"
                                                                :readonly="loading"
                                                                style="font-size: 1.5rem; text-align: center"
                                                                v-on:keyup="$root.unHighlightErrors('login_code_5')"
                                                                v-on:change="$root.unHighlightErrors('login_code_5')"
                                                            >
                                                        </div>
                                                    </div>
                                                    <div class="col-2 px-1">
                                                        <div class="form-group">
                                                            <input
                                                                v-model="code_6"
                                                                type="text"
                                                                v-mask="'######'"
                                                                id="login_code_6"
                                                                class="form-control mandatory-field"
                                                                :readonly="loading"
                                                                style="font-size: 1.5rem; text-align: center"
                                                                v-on:keyup="$root.unHighlightErrors('login_code_6')"
                                                                v-on:change="$root.unHighlightErrors('login_code_6')"
                                                            >
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group mt-3">
                                                    <button type="submit" class="btn btn-primary btn-block">
                                                        <i class="far fa-arrow-circle-right mr-1"></i>
                                                        {{ $root.text('Continue', null, true) }}
                                                    </button>
                                                </div>
                                                <div class="form-group">
                                                    <button
                                                        v-if="!resend_code_timer"
                                                        :key="'resend-code-button'"
                                                        type="button"
                                                        class="btn btn-secondary btn-block"
                                                        @click="toggleResendCode()"
                                                    >
                                                        <i class="far fa-undo-alt mr-1"></i>
                                                        {{ $root.text('Resend code', null, true) }}
                                                    </button>
                                                    <button
                                                        v-else
                                                        :key="'resend-code-button-disabled'"
                                                        type="button"
                                                        class="btn btn-secondary btn-block"
                                                        :disabled="true"
                                                    >
                                                        <i class="far fa-undo-alt mr-1"></i>
                                                        {{
                                                            $root.text(
                                                                'Resend code in {minutes}',
                                                                { minutes: resendCodeTime() },
                                                                true
                                                            )
                                                        }}
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>

                                    <div v-if="showForm()">
                                        <form v-on:submit.prevent="onSubmit()">
                                            <div class="form-group">
                                                <label for="email">{{ $root.text('Email', null, true) }}</label>
                                                <input v-model="email" type="email" id="email" class="form-control">
                                            </div>
                                            <div class="form-group">
                                                <label for="password">{{ $root.text('Password', null, true) }}</label>
                                                <input
                                                    v-model="password"
                                                    type="password"
                                                    id="password"
                                                    class="form-control"
                                                >
                                            </div>
                                            <div v-if="$root.client.allow_remember_me" class="form-group">
                                                <div class="custom-control custom-checkbox">
                                                    <input
                                                        v-model="remember_me"
                                                        type="checkbox"
                                                        class="custom-control-input"
                                                        id="remember_me"
                                                    >
                                                    <label class="custom-control-label" for="remember_me">
                                                        {{ $root.text('Remember me', null, true) }}
                                                    </label>
                                                </div>
                                            </div>
                                            <!--<div class="form-group">
                                                <tickbox
                                                    :field="'remember_me'"
                                                    v-model="remember_me"
                                                    :label="'Remember me'"
                                                ></tickbox>
                                            </div>-->
                                            <div class="form-group">
                                                <button type="submit" class="btn btn-primary btn-block">
                                                    <i class="far fa-sign-in-alt mr-1"></i>
                                                    {{ $root.text('Login', null, true) }}
                                                </button>
                                            </div>
                                        </form>

                                        <div v-if="canSso()" class="form-group">
                                            <button
                                                type="button"
                                                class="btn btn-secondary btn-block"
                                                @click="redirectToSso()"
                                            >
                                                <i class="far fa-id-badge mr-1"></i>
                                                {{ $root.app.saml_link_text }}
                                            </button>
                                        </div>

                                        <div class="form-group text-center">
                                            <a
                                                href="#"
                                                data-toggle="modal"
                                                data-target="#forgotten-password-modal"
                                                @click="resetForgottenPasswordForm()"
                                            >
                                                <i class="far fa-lock-alt mr-1"></i>
                                                {{ $root.text('Forgot your password?', null, true) }}
                                            </a>
                                        </div>

                                        <div
                                            v-if="$root.getSetting('allow_register', false)"
                                            class="form-group text-center"
                                        >
                                            <span>
                                                <a
                                                    href="#"
                                                    data-toggle="modal"
                                                    data-target="#register-modal"
                                                    @click="resetRegisterForm()"
                                                >
                                                    {{ $root.text("Don't have a login? Register now.", null, true) }}
                                                </a>
                                            </span>
                                        </div>
                                    </div>

                                    <div v-if="(!showForm() && !loading)">
                                        <div class="form-group text-center">
                                            <a href="#" @click.prevent="resetForm()">
                                                <i class="far fa-arrow-circle-left mr-1"></i>
                                                {{ $root.text('Back to login', null, true) }}
                                            </a>
                                        </div>
                                    </div>

                                    <div class="text-center" style="font-size: 0.7em; position: relative; height: 10px">
                                        {{ $root.text('Powered by', null, true) }}
                                        <a href="https://resourcebase.com" target="_blank">Resourcebase</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="$root.getSetting('allow_register', false)"
                class="modal fade"
                id="register-modal"
                data-backdrop="static"
                data-keyboard="false"
                tabindex="-1"
                aria-labelledby="register-modal-label"
                aria-hidden="true"
            >
                <div class="modal-dialog modal-dialog-scrollable modal-lg">
                    <register></register>
                </div>
            </div>

            <div
                class="modal fade"
                id="terms-modal"
                data-backdrop="static"
                data-keyboard="false"
                tabindex="-1"
                aria-labelledby="terms-modal-label"
                aria-hidden="true"
            >
                <div class="modal-dialog modal-dialog-scrollable modal-lg">
                    <terms-and-conditions
                        v-model="terms_accepted"
                        :must_accept="true"
                        :content="$parent.getTermsContent()"
                    ></terms-and-conditions>
                </div>
            </div>

        </div>

        <div
            class="modal fade"
            id="forgotten-password-modal"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="forgotten-password-modal-label"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-scrollable">
                <forgotten-password></forgotten-password>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                component_name: 'login',
                loading: false,
                errors: false,
                email: '',
                password: '',
                remember_me: false,
                password_expired: false,
                account_locked: false,
                user_unapproved: false,
                email_not_verified: false,
                terms_accepted: false,
                approval_chased: false,
                chase_approval_timer: 0,
                chase_approval_interval: null,
                can_chase: false,
                enter_code: false,
                code: '',
                code_1: '',
                code_2: '',
                code_3: '',
                code_4: '',
                code_5: '',
                code_6: '',
                resend_code: false,
                resend_code_timer: 0,
                resend_code_interval: null
            }
        },
        mounted () {
            $('body').addClass('login-body');
            this.$root.current_route = 'login';
            if (this.$route.params.password_reset_user_data) {
                this.$root.login_email = null;
                const userData = this.$root.base64Decode(this.$route.params.password_reset_user_data).split('||');
                this.email = userData[0];
                $('#forgotten-password-modal').modal('show');
                this.resetForgottenPasswordForm({
                    first_name: userData[1],
                    last_name: userData[2],
                    migrated: false
                });

                return null;
            }
            if (this.$root.login_email) {
                this.email = this.$root.login_email.toString();
                if (this.$root.login_password) {
                    this.password = this.$root.login_password.toString();
                    this.onSubmit();
                }
            }
            this.$root.login_email = null;
            this.$root.login_password = null;
        },
        beforeDestroy() {
            if (this.chase_approval_interval) {
                clearInterval(this.chase_approval_interval);
            }
            if (this.resend_code_interval) {
                clearInterval(this.resend_code_interval);
            }
        },
        watch: {
            terms_accepted: function (val) {
                if (val) {
                    this.onSubmit();
                }
            },
            email: function (val) {
                this.chase_approval_timer = 0;
            },
            enter_code: function (val) {
                if (!val) {
                    this.code = '';
                    this.code_1 = '';
                    this.code_2 = '';
                    this.code_3 = '';
                    this.code_4 = '';
                    this.code_5 = '';
                    this.code_6 = '';
                    this.resend_code = false
                }
            },
            code_1: function (val) {
                this.updateCode(val);
            },
            code_2: function (val) {
                this.updateCode(val);
            },
            code_3: function (val) {
                this.updateCode(val);
            },
            code_4: function (val) {
                this.updateCode(val);
            },
            code_5: function (val) {
                this.updateCode(val);
            },
            code_6: function (val) {
                this.updateCode(val);
            }
        },
        methods: {
            onSubmit: function (sendCode = false) {
                this.loading = true;
                this.errors = false;

                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/user/login';
                let data = {
                    email: this.email,
                    password: this.password,
                    terms_accepted: this.terms_accepted,
                    device: this.$root.getDevice(),
                    language_id: this.$root.current_language/*,
                    app_info: {
                        app_url: this.$root.app.app_url
                    }*/
                };
                if (sendCode) {
                    data.code = this.code;
                }
                var vm = this;

                /**
                 * Send login request to API.
                 */
                axios({
                    method: 'post',
                    url: url,
                    data: data
                })
                .then(response => {
                    if (!response.data.user) {
                        vm.enter_code = true;
                        vm.resend_code_timer = 5 * 60;
                        if (!vm.resend_code_interval) {
                            vm.resend_code_interval = setInterval(function () {
                                if (vm.resend_code_timer) {
                                    vm.resend_code_timer--;
                                }
                            }, 1000);
                        }

                        return null;
                    }
                    vm.$root.user = response.data.user;
                    vm.$root.token = response.data.token;

                    vm.$root.resetSystemVariables();

                    // Set current language.
                    if (vm.$root.languages.length > 0) {
                        let currentLanguage = response.data.user.language_id;
                        if (!currentLanguage) {
                            currentLanguage = vm.$root.current_language;
                        }
                        if (currentLanguage) {
                            if (
                                (vm.$root.current_language != currentLanguage)
                                || (response.data.user.language_id != currentLanguage)
                            ) {
                                let found = false;
                                vm.$root.languages.forEach((item) => {
                                    if (item.active && (item.id == currentLanguage)) {
                                        found = true;
                                    }
                                });

                                if (found) {
                                    vm.$root.setLanguage(
                                        currentLanguage,
                                        currentLanguage != response.data.user.language_id
                                    );
                                }
                            }
                        }
                    }
                    
                    // Create token cookie.
                    const days = (vm.$root.client.allow_remember_me && vm.remember_me) ? '1Y' : null;
                    vm.$root.setCookie(vm.$root.app.client_id + '_api_token', response.data.token, days);
                    vm.$root.getSelectedAssetsAndCollectionFromCookie();
                    vm.$root.getAssetsInfo();

                    // Show mega menu info modal?
                    vm.$root.showMegaMenuInfo();

                    // Redirect to requested page.
                    if (vm.$root.requested_route) {
                        if (!vm.$root.isProofsGuest() || (vm.$root.requested_route.name != 'home')) {
                            vm.$router.push({
                                name: vm.$root.requested_route.name,
                                params: vm.$root.requested_route.params,
                                query: vm.$root.requested_route.query
                            });
                            vm.$root.requested_route = null;

                            return null;
                        }
                        vm.$root.requested_route = null;
                    }
                    if (vm.$root.isPrintSupplier()) {
                        vm.$router.push({ name: 'my-account-print-orders' });

                        return null;
                    }
                    vm.$router.push({ name: vm.$root.isProofsGuest() ? 'proofs' : 'home' });
                })
                .catch(function (error) {
                    vm.errors = vm.$root.text('Something went wrong, please try again', null, true);
                    if (error.response) {
                        if (error.response.status == 503) {
                            vm.$root.showMaintenanceMessage(error.response.data.message);

                            return null;
                        }
                        if (error.response.status == 401) {
                            vm.errors = vm.$root.text('Invalid credentials. Please try again.', null, true);
                            if (error.response.data.error) {
                                if (error.response.data.error == 'Deleted') {
                                    vm.errors = vm.$root.text('Sorry, your account has been deleted.', null, true);
                                }
                                if (error.response.data.error == 'Locked') {
                                    vm.errors = vm.$root.text('For security your account is locked for 15 minutes. '
                                        + 'After this time, return to the login screen and try again. If you have '
                                        + "forgotten your password use the 'Forgotten password' link.", null, true);
                                    vm.account_locked = true;
                                }
                                if (error.response.data.error == 'Unapproved') {
                                    vm.errors = vm.$root.text('Your application is still being reviewed.', null, true);
                                    vm.user_unapproved = true;
                                    vm.$root.token = null;
                                    vm.$root.user = error.response.data.user;
                                    vm.$root.user.email = vm.email;
                                    vm.can_chase = error.response.data.can_chase;
                                }
                                if (error.response.data.error == 'NotVerified') {
                                    vm.errors = vm.$root.text('You need to verify your email address before you can '
                                        + 'login.', null, true) + '<br><br>' + vm.$root.text('Please check your email '
                                        + 'from this system and click on the email verification link.', null, true)
                                        + '<br><br>' + vm.$root.text('If you cannot find the email in your inbox,'
                                        + ' please check your spam/junk folders or email support.', null, true);
                                    vm.email_not_verified = true;
                                    vm.$root.token = null;
                                    vm.$root.user = error.response.data.user;
                                    vm.$root.user.email = vm.email;
                                }
                                if (error.response.data.error == 'TermsNotAccepted') {
                                    vm.errors = false;
                                    $('#terms-modal').modal('show');
                                }
                                if (error.response.data.error == 'Migrated') {
                                    vm.errors = false;
                                    $('#forgotten-password-modal').modal('show');
                                    let userData = error.response.data.user;
                                    userData.migrated = true;
                                    vm.resetForgottenPasswordForm(userData);
                                }
                            }
                        } else if (
                            (error.response.status == 406)
                            && (error.response.data.error.indexOf('login code already sent') < 0)
                        ) {
                            vm.errors = vm.$root.text('Your password has expired and needs to be changed.'
                                + ' Please click on Change password to set up a new one.', null, true);
                            vm.password_expired = true;
                        } else if (error.response.data.error) {
                            vm.errors = vm.$root.text(error.response.data.error, null, true);
                        }
                    }
                })
                .finally(() =>
                    vm.loading = false
                );
            },
            resetForm: function () {
                this.loading = false;
                this.errors = false;
                this.remember_me = false;
                var vm = this;
                setTimeout(function () {
                    vm.password_expired = false;
                    vm.account_locked = false;
                    vm.user_unapproved = false;
                    vm.email_not_verified = false;
                    vm.$root.user = null;
                    vm.approval_chased = false;
                    vm.can_chase = false;
                    vm.enter_code = false;
                    vm.resend_code = false;
                    vm.resend_code_timer = 0;
                }, 200);
            },
            showForm: function () {
                if (this.loading || this.password_expired || this.account_locked || this.approval_chased) {
                    return false;
                }
                if (this.enter_code) {
                    return false;
                }

                return (!this.user_unapproved && !this.email_not_verified);
            },
            resetForgottenPasswordForm: function (userData = null) {
                const component = this.$root.findComponent(this, 'forgotten-password');
                if (component) {
                    component.resetForm(userData);
                }
            },
            resetRegisterForm: function () {
                const component = this.$root.findComponent(this, 'register');
                if (component) {
                    component.resetForm();
                }
            },
            resetSupportForm: function (messageId) {
                const appComponent = this.$parent;
                const component = this.$root.findComponent(appComponent, 'email-support');
                if (component) {
                    if (messageId == 'locked') {
                        component.resetForm(
                            'access',
                            this.$root.text('I am unable to login, my account is locked', null, true)
                        );
                    }
                    if (messageId == 'unapproved') {
                        component.resetForm(
                            'access',
                            this.$root.text(
                                'Please review application from {name}',
                                { name: this.$root.user.first_name + ' ' + this.$root.user.last_name },
                                true
                            )
                        );
                    }
                    if (messageId == 'not-verified') {
                        component.resetForm(
                            'access',
                            this.$root.text('I have not received my email verification link', null, true)
                        );
                    }
                }
            },
            canSso: function () {
                if (!this.$root.app.saml_link_text) {
                    return false;
                }

                return true;
            },
            redirectToSso: function () {
                window.location.href = 'sso-saml.php';
            },
            chaseApproval: function () {
                if (!this.can_chase) {
                    return null;
                }
                this.errors = false;
                this.loading = true;
                this.user_unapproved = false;
                var vm = this;
                this.chase_approval_timer = 5 * 60;
                if (!vm.chase_approval_interval) {
                    vm.chase_approval_interval = setInterval(function () {
                        if (vm.chase_approval_timer) {
                            vm.chase_approval_timer--;
                        }
                    }, 1000);
                }

                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/user/chase-approval';
                const data = {
                    user_id: this.$root.user.id,
                    app_info: {
                        app_url: this.$root.app.app_url
                    }
                };

                /**
                 * Send login request to API.
                 */
                axios({
                    method: 'post',
                    url: url,
                    data: data
                })
                .then(response => {
                    vm.approval_chased = true;
                })
                .catch(function (error) {
                    vm.errors = vm.$root.text('Something went wrong, please try again', null, true);
                })
                .finally(() =>
                    vm.loading = false
                );
            },
            chaseApprovalTime: function () {
                if (this.chase_approval_timer < 60) {
                    return ('0' + this.chase_approval_timer).slice(-2);
                }
                const minutes = Math.floor(this.chase_approval_timer / 60);
                const seconds = this.chase_approval_timer - (minutes * 60);

                return minutes + ':' + ('0' + seconds).slice(-2);
            },
            updateCode: function (val) {
                if (val.length > 1) {
                    this.code_1 = val.substr(0, 1);
                    this.code_2 = val.substr(1, 1);
                    this.code_3 = val.substr(2, 1);
                    this.code_4 = val.substr(3, 1);
                    this.code_5 = val.substr(4, 1);
                    this.code_6 = val.substr(5, 1);
                }
                this.code = this.code_1 + this.code_2 + this.code_3 + this.code_4 + this.code_5 + this.code_6;

                var vm = this;
                setTimeout(function () {
                    if (vm.code.length == 6) {
                        $('.mandatory-field').blur();
                        $('.mandatory-label').removeClass('text-danger');
                    } else {
                        for (let digit = 6; digit >= 1; digit--) {
                            if ($('#login_code_' + digit).val() == '') {
                                $('#login_code_' + digit).focus();
                            }
                        }
                    }
                }, 20);
            },
            toggleResendCode: function () {
                this.resend_code = !this.resend_code;
            },
            resendCode: function () {
                this.resend_code = false;
                this.step = 2;
                this.code = '';
                this.code_1 = '';
                this.code_2 = '';
                this.code_3 = '';
                this.code_4 = '';
                this.code_5 = '';
                this.code_6 = '';
                this.onSubmit();
            },
            resendCodeTime: function () {
                if (this.resend_code_timer < 60) {
                    return ('0' + this.resend_code_timer).slice(-2);
                }
                const minutes = Math.floor(this.resend_code_timer / 60);
                const seconds = this.resend_code_timer - (minutes * 60);

                return minutes + ':' + ('0' + seconds).slice(-2);
            }
        }
    }
</script>
